export const DeprecatedTab = () => {
  return null;
};
